import React, { useEffect, useState } from 'react';
import apiClient from "../../ApiEndpoint/apiClient";
import { List, Typography, Space, Empty, Button } from 'antd';
import apiUrl from '../../ApiEndpoint/config';
import Spinner from "../Spinner/spinner.js";
import { of, from } from "rxjs";
import { debounceTime, switchMap, catchError } from "rxjs/operators";

const NewsList = () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const news$ = of(true).pipe(
      debounceTime(500), // wait before firing request
      switchMap(() =>
        from(
          apiClient.get(`${apiUrl}/epa_news?n=6`, { signal })
        ).pipe(
          catchError((error) => {
            console.error("Error fetching news:", error);
            return of({ data: [] }); // return empty fallback
          })
        )
      )
    );

    const subscription = news$.subscribe((response) => {
      setNewsData(response?.data || []);
      setLoading(false);
    });

    return () => {
      subscription.unsubscribe();
      controller.abort(); // cancel pending API if unmounted
    };
  }, []);

  return (
    <div style={{ border: "1px solid #ddd", borderRadius: 8, padding: 16 }}>
      <Typography.Title
        level={5}
        style={{ borderBottom: "2px solid #52c41a", paddingBottom: 8 }}
      >
        Relevant News
      </Typography.Title>

      <div style={{ maxHeight: "78vh", overflowY: "auto" }}>
        {loading ? (
          <Spinner />
        ) : newsData.length > 0 ? (
          <List
            dataSource={newsData}
            renderItem={(item, index) => (
              <List.Item
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "12px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <Typography.Text strong style={{ fontSize: 16 }}>
                  {item.Title}
                </Typography.Text>
                <Typography.Text type="secondary" style={{ marginBottom: 8 }}>
                  {new Date(item.date).toLocaleDateString()}
                </Typography.Text>
                <Button
                  type="primary"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  size="small"
                >
                  Read More
                </Button>
              </List.Item>
            )}
          />
        ) : (
          <Empty description="No data found" />
        )}
      </div>

    </div>
  );
};

export default NewsList;
